import API from './base';

const version = 'v1';
const search = '/search';

export default {
  getSearchResults(payload) {
    return API.get(`${version}${search}`, {
      params: payload,
    });
  },
};
